import { useTranslation } from "react-i18next";
import { Form } from "react-bootstrap";

const StandardUserForm = ({ users, noLabel, handleChange }) => {
  const { t } = useTranslation("admin");
  return (
    <div className="my-3">
      {noLabel === false && <h6>{t("choose_a_user")}</h6>}
      <Form.Control as="select" className="my-3" onChange={handleChange}>
        <option>{t("choose_a_user")}</option>
        {users?.map((user) => (
          <option key={user.id} value={user.id}>
            {user.id} - {user.first_name} {user.last_name}
          </option>
        ))}
      </Form.Control>
    </div>
  );
};

export default StandardUserForm;